interface prop {
  text: string;
  color: string;
  textColor?: string;
  disabled?: boolean;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  icon?: string;
  border?: string;
  type?: "button" | "submit" | "reset";
  iconClassName?: string;
  iconPosition?: "left" | "right";
  padding?: "px-2" | "px-3" | "px-4" | "px-6";
}

export default function SubButton({
  text,
  color = "bg-primary-500",
  textColor = "text-white",
  onClick,
  disabled,
  icon,
  border,
  type = "button",
  iconClassName,
  iconPosition = "left",
  padding= "px-2"
}: prop) {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`${color} ${textColor} ${border} rounded w-fit flex items-center justify-center capitalize text-nowrap py-[6px] ${padding} text-[13px] font-medium disabled:opacity-30 disabled:cursor-not-allowed ${icon ? "gap-2" : ""}`}
    >
      {icon && iconPosition === "left" && (
        <img src={icon} alt="" className={`w-4 h-4 ${iconClassName}`} />
      )}

      {text}

      {icon && iconPosition === "right" && (
        <img src={icon} alt="" className={`w-4 h-4 ${iconClassName}`} />
      )}
    </button>
  );
}
